import { ruLocale } from './ru'

export const locale = ruLocale
